/* eslint-disable react/prop-types */
import React from 'react';

// import ContinueAs from '../../../common/containers/ContinueAsContainer';
import CredentialBoxWrapper from '../../layouts/CredentialsBoxWrapper';
import ForgotPasswordBox from '../../components/ForgotPasswordBox';
import loginEnhancer from '../../containers/LoginEnhancer';
import { retrieveUriParam } from '../../../../utils/helpers';

export const ForgotPasswordConfirm = ({ ...props }) => {
  const appName = retrieveUriParam('app_name');
  const code = retrieveUriParam('code');
  return (
    <CredentialBoxWrapper title={appName || 'Sign In'}>
      <ForgotPasswordBox confirm code={code} {...props} />
    </CredentialBoxWrapper>
  );
};

export default loginEnhancer(ForgotPasswordConfirm);



// WEBPACK FOOTER //
// ./src/views/sports-connect/pages/ForgotPasswordConfirm/index.js